import React, { useState, useEffect } from 'react';
import  CheckBox  from '../../Checkbox';
import LoaderComponent from '../../Loader';


const ZipLocation = (props) => {

    const [zipLocData, setZipLocData] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [isZipSelectedOrNot, setIsZipSelectedOrNot] = useState({});
    const [zipSelected, setZipSelected]=useState([]);
    const [checkOptions, setCheckOptions]=useState([]);

    useEffect(() => {
        props.fetchZipData();
    }, [])

    useEffect(() => {
        if (props.zipData && props.zipData.length > 0) {
            let zipKeyList = {};
            let CheckboxOptions=[];
            props.zipData[0].entries.forEach((item) => {
                zipKeyList[item.id] = false;
                CheckboxOptions.push({id:item.id,label:item.displayText,checked:false})
            })
        setCheckOptions(CheckboxOptions);
        setZipLocData(props.zipData);
        setIsZipSelectedOrNot(zipKeyList);
        }

    }, [props.zipData]);


    const handleCheckbox = (evt) => {
        evt.checked=!evt.checked;
        let isZipSelectedOrNotData = isZipSelectedOrNot, isAllZipSelected = false;
        if (evt.id != zipLocData[0].id) {
            if (isZipSelectedOrNotData.hasOwnProperty(evt.id) && isZipSelectedOrNotData[evt.id] == true) {
                isZipSelectedOrNotData[evt.id] = false;
            }
            else {
                isZipSelectedOrNotData[evt.id] = true;
            }

            isAllZipSelected = Object.keys(isZipSelectedOrNot).every(key=>isZipSelectedOrNot[key]==true);
        }
        else {
            checkOptions.forEach((item) => {
                if (evt.checked) {
                    isZipSelectedOrNotData[item.id] = true;
                    item.checked=true;
                }
                else if (!evt.checked) {
                    isZipSelectedOrNotData[item.id] = false;
                    item.checked=false;
                }
            });
            isAllZipSelected = evt.checked;
        }
        const selectedZipsData = Object.keys(isZipSelectedOrNot).filter(key => isZipSelectedOrNot[key]);
        setIsAllSelected(isAllZipSelected);
        setIsZipSelectedOrNot(isZipSelectedOrNotData);
        setZipSelected(selectedZipsData);
        setCheckOptions([...checkOptions])
    }

    const addZipLocation=()=>{
        if(zipLocData.length==0) {
            return;
        } else if(zipSelected.length >0)
        {
            let zipData=[];
            if(Object.keys(isZipSelectedOrNot).every(key=>isZipSelectedOrNot[key]==true)) { 
            zipData.push({id:zipLocData[0].id, value:zipLocData[0].displayText});    
           }
           else{
            checkOptions.forEach(item=>{
                if(zipSelected.includes(item.id))
                {
                    zipData.push({id:item.id, value:item.displayText});
                }
            })
        }
        props.addZipLocation(zipData);
        }
        else{
            props.onCancelClick();
        }
    }
    let checkboxData;
    if(zipLocData?.length) {
        checkboxData= {id:zipLocData[0].id,label:zipLocData[0].displayText,checked:isAllSelected}
    }
    return (
        <div className="modalHeader">
            <div className="alignMiddle rowSpaceBetween">All Zips</div>
            <div className="content modalBody pd__none mt__1">
                {
                    <div className="all-zip">
                        {zipLocData?.length > 0 ?
                            <ul>
                                <li>
                                    <div className="rowFlex">

                                      {checkboxData && <CheckBox item={checkboxData} handleCheckbox={handleCheckbox}/> }
                                    </div>
                                    <ul>
                                        <li>
                                            <div className="rowFlex">
                                                {
                                                  checkOptions.length > 0 && checkOptions.map((item, index) => {
                                                        return (<div key={index} className="mr__1">
                                                                <CheckBox item={item} handleCheckbox={handleCheckbox}/>
                                                                </div>)
                                                    })
                                                }
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                            </ul> : <LoaderComponent />}
                            
                    </div>
                }
            </div>
                <div id="btnNotePopup" className="modalFooter pd__none">
                    <button type="button" onClick={()=>addZipLocation()} id="btnSaveZip" className="btn default buttonGradient">Publish</button>
                    <button onClick={() => props.onCancelClick()} id="btnCancelZip" className="btn link">Cancel</button>
                </div>
            </div>)
}


export default ZipLocation;